import { useSessionContext } from "@supabase/auth-helpers-react";


import { useEffect, useState } from "react";

/** I found myself checking the session from useSession very often to check if the user
 *  is logged in or not, so I thought I'd make a separate hook with a more explicit name
 *  for doing this. */
export const useIsUserLoggedIn = () => {
  const {
    session
  } = useSessionContext();
  const [ isLoggedIn, setIsLoggedIn ] = useState<boolean | null>(null);
  const [ isLoadingState, setIsLoadingState ] = useState<boolean>(true);

  useEffect(() => {
    if (session === undefined || !session?.user) {
      setIsLoggedIn(null);
    } else if (session && session.user.aud === "authenticated") {
      setIsLoadingState(false);
      setIsLoggedIn(true);
    } else {
      setIsLoadingState(false);
      setIsLoggedIn(false);
    }
  }, [ session ]);

  return { isLoggedIn, isLoading: isLoadingState };
};

